<template>
  <div class="mantenimiento-page fill-height">
    <v-row no-gutters class="mantenimiento-row">
      <v-col
        cols="12"
        md="6"
        class="mantenimiento-brand pa-8 pa-md-12 d-none d-md-flex flex-column justify-center"
      >
        <div class="mantenimiento-brand__inner">
          <v-icon color="white" size="56" class="mantenimiento-brand__icon">
            mdi-wrench-clock
          </v-icon>
          <h1 class="mantenimiento-brand__title">Mantenimiento programado</h1>
          <p class="mantenimiento-brand__subtitle">
            Estamos mejorando la plataforma para ofrecerte una mejor experiencia.
          </p>
        </div>
      </v-col>

      <v-col
        cols="12"
        md="6"
        class="mantenimiento-content-col pa-6 pa-sm-10 pa-md-12 d-flex align-center justify-center"
      >
        <div class="mantenimiento-content-wrap text-center">
          <v-img
            src="@/assets/logo.png"
            max-height="52"
            contain
            class="mx-auto mantenimiento-logo mb-8"
            alt="School of English"
          />

          <v-icon color="warning" size="72" class="mb-6">
            mdi-tools
          </v-icon>

          <h2 class="mantenimiento-heading mb-3">Plataforma en mantenimiento</h2>

          <p class="mantenimiento-lead mb-6">
            {{ mensaje }}
          </p>

          <v-chip color="amber lighten-4" text-color="amber darken-4" class="px-4">
            <v-icon left small>mdi-clock-outline</v-icon>
            Vuelve a intentar en unos minutos
          </v-chip>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { MANTENIMIENTO_MENSAJE } from '@/config/mantenimiento'

export default {
  name: 'Mantenimiento',
  data() {
    return {
      mensaje: MANTENIMIENTO_MENSAJE,
    }
  },
}
</script>

<style scoped>
.mantenimiento-page {
  min-height: 100vh;
  background: #fff;
}

.mantenimiento-row {
  min-height: 100vh;
}

.mantenimiento-brand {
  background: linear-gradient(155deg, #0d1b3e 0%, #1a3a6e 45%, #2563a8 100%);
  color: #fff;
  position: relative;
  overflow: hidden;
}

.mantenimiento-brand::before {
  content: '';
  position: absolute;
  width: min(420px, 90vw);
  height: min(420px, 90vw);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  top: -18%;
  right: -12%;
  pointer-events: none;
}

.mantenimiento-brand__inner {
  position: relative;
  z-index: 1;
  max-width: 400px;
}

.mantenimiento-brand__icon {
  opacity: 0.92;
  margin-bottom: 1.25rem;
}

.mantenimiento-brand__title {
  font-size: 1.75rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1.25;
  margin-bottom: 0.75rem;
}

.mantenimiento-brand__subtitle {
  font-size: 0.95rem;
  line-height: 1.55;
  opacity: 0.88;
  margin: 0;
}

.mantenimiento-content-col {
  background: #fff;
}

.mantenimiento-content-wrap {
  width: 100%;
  max-width: 420px;
}

.mantenimiento-logo {
  max-width: 280px;
}

.mantenimiento-heading {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1a202c;
  letter-spacing: -0.02em;
}

.mantenimiento-lead {
  font-size: 0.95rem;
  color: #64748b;
  line-height: 1.6;
  margin: 0;
}

@media (max-width: 959px) {
  .mantenimiento-content-col {
    min-height: 100vh;
  }
}
</style>
